export default "__VITE_ASSET__DQav6SYz__"